import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-monitoring-mode-countdown-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  template: `
    <div class="monitoring-countdown-dialog">
      <h2 mat-dialog-title>Entering Monitoring Mode</h2>
      <mat-dialog-content>
        <p class="message">
          You have been inactive. The system will switch to read-only monitoring mode.
        </p>
        <div class="countdown-container">
          <div class="countdown-timer" [ngClass]="{ warning: countdown <= 3 }">
            {{ countdown }}s
          </div>
          <p class="countdown-text">Automatic activation in {{ countdown }} second{{ countdown === 1 ? '' : 's' }}</p>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button
          mat-button
          (click)="onCancel()"
          class="cancel-btn"
          cdkFocusInitial
        >
          Cancel
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styleUrl: './monitoring-mode-countdown-dialog.component.scss',
})
export class MonitoringModeCountdownDialogComponent implements OnInit, OnDestroy {
  countdown: number = 10;
  private countdownSub?: Subscription;

  constructor(private dialogRef: MatDialogRef<MonitoringModeCountdownDialogComponent>) {}

  ngOnInit(): void {
    // Start countdown from 10 to 0
    this.countdownSub = interval(1000)
      .pipe(
        takeWhile(() => this.countdown > 0)
      )
      .subscribe(() => {
        this.countdown--;
        if (this.countdown === 0) {
          // Auto-close dialog when countdown reaches 0
          console.log('[MonitoringModeCountdownDialog] Countdown finished, auto-closing');
          this.dialogRef.close({ action: 'auto-confirm' });
        }
      });
  }

  ngOnDestroy(): void {
    if (this.countdownSub) {
      this.countdownSub.unsubscribe();
    }
  }

  onCancel(): void {
    console.log('[MonitoringModeCountdownDialog] User clicked Cancel');
    this.dialogRef.close({ action: 'cancel' });
  }
}
